import { render, staticRenderFns } from "./burs-modal.vue?vue&type=template&id=e2af9bc0&"
import script from "./burs-modal.vue?vue&type=script&lang=js&"
export * from "./burs-modal.vue?vue&type=script&lang=js&"
import style0 from "./burs-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports